export default __webpack_public_path__ + "static/media/skills-hub-icon.4afce7fb.svg";